<template>
  <div
    class="flex items-center justify-center min-h-screen bg-white dark:bg-zinc-950"
  >
    <div class="text-center">
      <!-- Logo -->
      <div class="mb-16">
        <NuxtImg
          src="/images/logos/HighfieldLogos/svg/highfield_long_black.svg"
          alt="Highfield"
          class="h-10 mx-auto dark:hidden"
          loading="lazy"
        />
        <NuxtImg
          src="/images/logos/HighfieldLogos/svg/highfield_long_white.svg"
          alt="Highfield"
          class="h-10 mx-auto hidden dark:block"
          loading="lazy"
        />
      </div>

      <!-- Error Code -->
      <h1
        class="text-9xl md:text-[150px] font-black text-gray-900 dark:text-white mb-16 leading-none"
      >
        {{ statusCode }}
      </h1>

      <!-- Home Button -->
      <NuxtLink
        to="/"
        class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-900 dark:bg-white text-white dark:text-gray-900 hover:opacity-70 transition-opacity duration-300"
        title="Voltar à Home"
      >
        <Icon name="material-symbols:home" class="text-2xl" />
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

defineProps<{
  error: {
    statusCode: number;
    statusMessage: string;
    message?: string;
  };
}>();

definePageMeta({
  hideLayout: true,
});

const statusCode = computed(() => {
  return useError()?.statusCode || 500;
});
</script>
